import { useMemo } from 'react'
import { FormikProps } from 'formik'

import { useUtils, useCompanyDetails } from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'
import useUserAccountType from 'utils/hooks/useUserAccountType'
import { SelectField } from 'components/FormFields/FormFields'
import { FormValues } from '../CreateContentModal'

type VerticalSelectorProps = {
  formikProps: FormikProps<FormValues>
  defaultValue: (props: FormikProps<FormValues>) => number | undefined
  className?: string
}

export const VerticalSelector = ({
  formikProps,
  defaultValue,
  className,
}: VerticalSelectorProps): JSX.Element => {
  const accountType = useUserAccountType()
  const { verticals } = useUtils()
  const companyId = useSelectedCompanyId()
  const { data: company } = useCompanyDetails(
    `/companies/${companyId}`,
    companyId
  )

  const verticalsOptionsList = useMemo(() => {
    if (!company) return []

    return verticals
      .filter(vertical => {
        if (company?.all_verticals_access_flag) return true

        if (vertical.unrestricted_flag === 0) return false

        if (accountType === 'standard') {
          if (!vertical.display.includes('client_sme')) return false

          return true
        }

        if (accountType !== 'enterprise') return false

        if (!vertical.display.includes('client_enterprise')) return false

        return true
      })
      .map(vertical => ({ label: vertical.title, value: vertical.id }))
  }, [company, verticals, accountType])

  return (
    <SelectField
      name="verticalId"
      label="Content type"
      actions={formikProps}
      className={className}
      defaultValue={() => defaultValue?.(formikProps)}
      fieldProps={{
        options: verticalsOptionsList,
        shouldShowSearchV2: true,
        placeholder: 'Select content type',
        defaultSearchHeader: 'Select from the list or type to search',
        showSearch: true,
      }}
      required={true}
      loadV2={true}
    />
  )
}
